import { render, staticRenderFns } from "./ReceiptSummary.component.vue?vue&type=template&id=4d4d90a7&scoped=true"
import script from "./ReceiptSummary.component.vue?vue&type=script&lang=js"
export * from "./ReceiptSummary.component.vue?vue&type=script&lang=js"
import style0 from "./ReceiptSummary.component.vue?vue&type=style&index=0&id=4d4d90a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d90a7",
  null
  
)

export default component.exports